/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Guest_Book_Sent_BodyInputs */

const en_guest_book_sent_body = /** @type {(inputs: Guest_Book_Sent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a link to ${i?.email}. Click it within 30 minutes to confirm the booking.`)
};

const pl_guest_book_sent_body = /** @type {(inputs: Guest_Book_Sent_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłaliśmy link na ${i?.email}. Kliknij go w ciągu 30 minut, żeby potwierdzić rezerwację.`)
};

/**
* | output |
* | --- |
* | "We sent a link to {email}. Click it within 30 minutes to confirm the booking." |
*
* @param {Guest_Book_Sent_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_sent_body = /** @type {((inputs: Guest_Book_Sent_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_Sent_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_sent_body(inputs)
	return en_guest_book_sent_body(inputs)
});